<template>
  <div class="edit-last-mile card">
    <page-header
      title="Route Schedule"
      breadcrumbText="Dashboard >> Settings >> Routes >> Lagos - Rivers >> Edit Route Schedule"
    />
    <div class="mt-3">
      <p class="font-semibold text-primary-blue">
        Update Route Schedule
      </p>
    </div>

    <div class="forward-trip mt-3">
      <div>
        <p class="text-secondary-orange font-semibold">Forward Trip</p>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-6 col-12">
            <label class="label">Day</label>
            <el-select v-model="selectedState" placeholder="Select">
              <el-option
                v-for="state in states"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-6 col-12">
            <label class="label">Time</label>
            <el-select v-model="selectedState" placeholder="Select">
              <el-option
                v-for="state in states"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-6 col-12">
            <label class="label">Standard Shipping Time</label>
            <el-select v-model="selectedState" placeholder="Select">
              <el-option
                v-for="state in states"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-6 col-12">
            <label class="label">Express Delivery</label>
            <el-select v-model="selectedState" placeholder="Select">
              <el-option
                v-for="state in states"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="return-trip mt-3">
      <div>
        <p class="text-secondary-orange font-semibold">Return Trip</p>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-6 col-12">
            <label class="label">Day</label>
            <el-select v-model="selectedState" placeholder="Select">
              <el-option
                v-for="state in states"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-6 col-12">
            <label class="label">Time</label>
            <el-select v-model="selectedState" placeholder="Select">
              <el-option
                v-for="state in states"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-6 col-12">
            <label class="label">Standard Shipping Time</label>
            <el-select v-model="selectedState" placeholder="Select">
              <el-option
                v-for="state in states"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-6 col-12">
            <label class="label">Express Delivery</label>
            <el-select v-model="selectedState" placeholder="Select">
              <el-option
                v-for="state in states"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="button-wrapper my-4">
      <button class="button-secondary button-long button">Cancel</button>
      <button class="button-primary button-long button">Save</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      states: ["Abia", "Adamawa"],
      selectedState: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.row > div {
  margin-bottom: 1.5rem;
}
</style>
